import { useCallback } from 'react'
import { useDisplayPlanContents } from '~/features/reservationInput/store/plan'
import { money } from '~/lib/money/money'
import { useReserveNavigate, useSendClickEvent } from '~/navigation'
import { sva } from '~/styled-system/css'

const styles = sva({
  slots: ['container', 'title', 'content', 'label', 'bottom', 'link', 'price', 'value', 'charge'],
  base: {
    container: {
      spaceY: '2',
      md: {
        display: 'flex',
        alignItems: 'start',
        spaceY: '0',
        spaceX: '3',
      },
    },
    title: {
      width: '[100px]',
      fontSize: 'sm',
      fontWeight: 'bold',
      md: {
        fontSize: 'md',
        flexShrink: '0',
      },
    },
    content: {
      spaceY: '2',
      width: 'full',
    },
    label: {
      md: {
        fontSize: 'md',
      },
    },
    bottom: {
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'space-between',
    },
    link: {
      fontSize: 'sm',
      color: 'link',
    },
    price: {
      textAlign: 'right',
    },
    value: {
      fontSize: 'lg',
    },
    charge: {
      fontSize: 'xs',
      color: 'gray.700',
    },
  },
})

export function PlanContents() {
  const { display, onClick } = usePlanContents()
  if (display === undefined) {
    return null
  }

  const classes = styles()

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>{display.props.title}</h2>
      <div className={classes.content}>
        <p className={classes.label}>{display.label}</p>
        <div className={classes.bottom}>
          <button type="button" className={classes.link} onClick={onClick}>
            {display.type === 'course' ? 'プラン詳細' : '詳細'}
          </button>
          {display.type === 'course' && (
            <div className={classes.price}>
              <p className={classes.value}>{money(display.price)}円</p>
              <p className={classes.charge}>{display.props.annotation}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

function usePlanContents() {
  const display = useDisplayPlanContents()
  const navigate = useReserveNavigate()
  const sendClickEvent = useSendClickEvent()
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      sendClickEvent({ plan: 'detail', click_event: 'ReserveInput/plan/detail' })
      e.stopPropagation()
      navigate({ type: 'openCourseDetail' })
    },
    [navigate, sendClickEvent]
  )
  return { display, onClick }
}
